"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var components_1 = require("stremio/components");
var EPG_1 = require("stremio/common/EPG");
var Header_less_1 = __importDefault(require("./Header.less"));
var HALF_HOUR_IN_MS = EPG_1.HOUR_IN_MS / 2;
var Header = function (_a) {
    var headerRef = _a.headerRef, channelColumnWidth = _a.channelColumnWidth, dayStart = _a.dayStart, dayEnd = _a.dayEnd, pixelsPerHour = _a.pixelsPerHour, viewport = _a.viewport, ticks = _a.ticks, totalGridWidth = _a.totalGridWidth, onZoom = _a.onZoom, onScrollToTime = _a.onScrollToTime;
    var t = (0, react_i18next_1.useTranslation)().t;
    var slots = (0, react_1.useMemo)(function () {
        var times = Array.from({ length: Math.ceil((dayEnd - dayStart) / HALF_HOUR_IN_MS) }, function (_, index) {
            var date = new Date(dayStart + index * HALF_HOUR_IN_MS);
            return { index: index, date: date, label: date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) };
        });
        // Fall-back days contain repeated local times. Include the offset for those choices.
        return times.map(function (slot) { return ({
            label: times.some(function (other) { return other.index !== slot.index && other.label === slot.label; }) ?
                slot.date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', timeZoneName: 'shortOffset' })
                :
                    slot.label,
            value: slot.index,
        }); });
    }, [dayStart, dayEnd]);
    var selectedSlot = Math.max(0, Math.min(slots.length - 1, Math.floor((viewport.left + viewport.width / 2) / (pixelsPerHour / 2))));
    var canZoomOut = pixelsPerHour > EPG_1.EPG_MIN_PIXELS_PER_HOUR;
    var canZoomIn = pixelsPerHour < EPG_1.EPG_MAX_PIXELS_PER_HOUR;
    var tickIndexes = Array.from({ length: Math.max(0, ticks.last - ticks.first) }, function (_, index) { return ticks.first + index; });
    var onSlotSelect = (0, react_1.useCallback)(function (value) {
        var index = Number(value);
        if (value !== null && Number.isInteger(index) && index >= 0 && index < slots.length) {
            onScrollToTime(dayStart + (index + 0.5) * HALF_HOUR_IN_MS);
        }
    }, [dayStart, slots.length, onScrollToTime]);
    var onZoomOut = (0, react_1.useCallback)(function () { return onZoom(0.5); }, [onZoom]);
    var onZoomIn = (0, react_1.useCallback)(function () { return onZoom(2); }, [onZoom]);
    return (react_1.default.createElement("div", { className: Header_less_1.default['header'] },
        react_1.default.createElement("div", { className: Header_less_1.default['controls'], style: { width: channelColumnWidth } },
            react_1.default.createElement(components_1.MultiselectMenu, { className: Header_less_1.default['time-menu'], icon: 'clock', portal: true, options: slots, value: selectedSlot, onSelect: onSlotSelect }),
            react_1.default.createElement("div", { className: Header_less_1.default['zoom-controls'] },
                react_1.default.createElement(components_1.Button, { role: 'button', "aria-label": t('LIVE_TV_ZOOM_OUT', { defaultValue: 'Zoom out' }), disabled: !canZoomOut, "aria-disabled": !canZoomOut, tabIndex: canZoomOut ? 0 : -1, onClick: onZoomOut },
                    react_1.default.createElement("div", { className: Header_less_1.default['zoom-icon'], "aria-hidden": 'true' })),
                react_1.default.createElement(components_1.Button, { role: 'button', "aria-label": t('LIVE_TV_ZOOM_IN', { defaultValue: 'Zoom in' }), disabled: !canZoomIn, "aria-disabled": !canZoomIn, tabIndex: canZoomIn ? 0 : -1, onClick: onZoomIn },
                    react_1.default.createElement("div", { className: (0, classnames_1.default)(Header_less_1.default['zoom-icon'], Header_less_1.default['zoom-in']), "aria-hidden": 'true' })))),
        react_1.default.createElement("div", { ref: headerRef, className: Header_less_1.default['viewport'], style: { width: viewport.width } },
            react_1.default.createElement("div", { className: Header_less_1.default['time-slots'], style: { width: totalGridWidth } }, tickIndexes.map(function (index) { return (react_1.default.createElement("div", { key: index, className: Header_less_1.default['time-slot'], style: { left: index * ticks.width, width: ticks.width } }, new Date(dayStart + index * ticks.size).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }))); })))));
};
exports.default = Header;
